import moment from 'moment';
import { DEFAULT_DATE_FORMAT } from 'api/models';
export const formatDate = (date, format)=>moment(date).format(format !== null && format !== void 0 ? format : DEFAULT_DATE_FORMAT);
export const getDueDateForGantt = (dueDate)=>formatDate(moment(dueDate).add(1, 'day'));
export const getDueDateFromGantt = (entity, format)=>formatDate(moment(entity.endDate).subtract(1, 'day'), format);
